import React, { ReactChild, ReactNode, useEffect, useState } from 'react'
import { Card, Icon, Text } from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from './styles.scss'
const cx = _cx.bind(cls)
const elmId = 'card_tab'

interface CardTabItem {
  beforeChild?: ReactNode
  description: string
  elmId: string
  icon: string
  render: ReactNode
  title: string
}
interface CardTabProps {
  cards: CardTabItem[]
  children?: (index: number) => ReactChild
  index?: number
}

const CardTab = ({ index = 0, cards, children }: CardTabProps) => {
  const [localIndex, setLocalIndex] = useState(0)

  useEffect(() => {
    setLocalIndex(index)
  }, [index])

  if (!cards || cards.length <= 0 || localIndex >= cards.length) return null

  return (
    <>
      <div className={cx('cards')}>
        {cards.map((card, i) => (
          <Card
            className={cx('card', { active: localIndex === i })}
            key={i}
            data-elm-id={`${elmId}_${card.elmId}`}
            onClick={() => setLocalIndex(i)}
          >
            <Card.Content
              className={cx('head')}
              header={
                <>
                  <div className={cx('u-mb-1', 'u-mt-1')}>
                    <Icon
                      data-elm-id={`card_icon_${card.icon}`}
                      name={card.icon}
                      color='white'
                      iconStyle='regular'
                      size='big'
                    />
                  </div>
                  <Text color='white' weight='heavy'>
                    {card.title}
                  </Text>
                </>
              }
            />
            <Card.Content
              className={cx('content')}
              description={card.description}
            />
          </Card>
        ))}
      </div>
      <div className={cx('content')}>
        {cards[localIndex].beforeChild}
        {children?.(localIndex)}
        {cards[localIndex].render}
      </div>
    </>
  )
}

export default CardTab
